<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src="../../../assets/snakes.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              REPORT DETAILS &nbsp;
              <!-- <router-link :to="'/sightingsloc1/'+this.id ">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>-->
            </h4>
            <div class="row pt-4">
              <!-- <div class="col-2">
                <div class="row pl-3">
                    <enlargeable-image v-if="im" v-bind:src="image" v-bind::src_large="image">
                    <img :src="image" v-if="im" style="width:100%;height:auto;" />
                    </enlargeable-image>
                </div>
              </div> -->

              <div class="col-md-6" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>Report Details</tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Description</th>
                      <td>{{data.reportId.description}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake</th>
                      <td v-if="data.reportId.snake != undefined">{{data.reportId.snake.name}}</td>
                      <td v-else>Not Known</td>
                    </tr>
                    <tr >
                      <th scope="col">Created At</th>
                      <td>{{data.reportId.createdAt.slice(0,10)}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Situation</th>
                      <td>{{data.reportId.situation}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Division Name</th>
                      <td v-if="data.division.length > 0">{{data.division[0].divisionName}}</td>
                    </tr>
                     <tr>
                      <th scope="col">District</th>
                      <td>{{data.district}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-md-6" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>Reported By</tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Name</th>
                      <td>{{data.reportId.user.name}}</td>
                    </tr>
                     <tr>
                      <th scope="col"><v-flex
                                xs12
                                sm6
                                lg4
                                md6
                                pt-2
                                v-if="data && data.reportId"
                              >
                                <v-flex xs12 text-left>
                                  <span class="itemKey">Name</span>
                                </v-flex>
                                <v-flex xs12 text-left>
                                  <span class="itemValue">
                                    {{data.reportId.user.name}}
                                    <span v-if="!data.reportId.user.name">-</span>
                                  </span>
                                </v-flex>
                              </v-flex></th>
                      <td>{{data.reportId.user.phone}}</td>
                    </tr>
                     <tr>
                      <th scope="col">Email</th>
                      <td>{{data.reportId.user.email}}</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
             <hr>
                <div class="col-md-12">
              <p><b>Photographs</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in reportedimages" :src="src" :key="src">
    </div>
              </div>
              <hr>
             <div class="col-md-12">
               <div id="map"></div>
            </div>
            <br><br>
              <div class="col-md-12">
              <div class="row">
                 <div class="col-md-4">
                  <button v-b-modal.modal-footer-sm-close class="btn btn-warning">Close Operation</button>
            </div>
             <div class="col-md-4">
                <button class="btn btn-danger" @click="deleteItem()">Delete Operation</button>
             </div>
              </div>
            </div>
             <b-modal id="modal-footer-sm-close" title button-size="sm">
                  <form @submit="close">
                   
                   
                    <div class="form-group">
                      <label for="exampleInputEmail1">Remarks</label>
                      <textarea
                        class="form-control"
                        id="exampleInputEmail1"
                        v-model="closingremarks"
                        aria-describedby="emailHelp"
                        placeholder="Remarks"
                        rows="10"
                        
                      />
                    </div>
                    <button class="btn btn-success" type="submit">SUBMIT</button>
                  </form>
                </b-modal>
            <!-- <div class="row">
                  <form @submit="assign">
    

                    <div class="form-group">
                      <h4 for="exampleInputEmail1">Assign to Rescuer</h4>
                      <br>
                      <div class="col-md-12">
                        <b-checkbox
                          v-for="itm in item"
                          :key="itm._id"
                          v-bind:value="itm.user._id"
                          name="flavour-4a"
                          v-model="assignedTo"
                        >
                          <div class="pb-2">
                            <div class="px-2 pl-1 pr-5">
                              <span class="row">
                                <span class="col-md-2">
                                  <img
                                    :src="'https://sarpatnapi.leopardtechlabs.in/u/'+itm.user.photo"
                                    class="circular--square"
                                    style="width:30px;height:30px;"
                                  />
                                </span>
                                <span class="col-md-10" style="padding-right:10px;">
                                  {{ itm.user.name }}<br>
                                  No of Rescues : {{itm.noOfRescues}}
                                </span>
                              </span>
                            </div>
                          </div>
                        </b-checkbox>
                      </div>
                    </div>

                    <button class="btn btn-success" type="submit">ASSIGN</button>
                  </form>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
var marker;
export default {
  components: {
    EnlargeableImage,
  },
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      image: null,
      name: "",
      data: '',
      userdata: [],
      loading: false,
      im: "",
      rescuerCode: "",
      idType: "",
      idNumber: "",
      reason: "",
      divisionid: "",
      item: [],
      assignedTo: "",
      divi: "",
      option: [],
       oMarker: [],
       reportedimages: [],
       closingremarks: "",
    };
  },
  mounted: function () {
    this.getview();
  },

  methods: {
    getview() {
      this.loading = true;
      var mapCanvas = document.getElementById('map')
     
      var vm = this
      // eslint-disable-next-line
    
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/operation/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.data = response.data.data;
            var temp1 = response.data.reportedimages;
              for(var j=0;j<temp1.length;j++){
              var ty =  "https://sarpatnapi.leopardtechlabs.in/u/"+temp1[j]
               this.reportedimages.push(ty);
            }
            this.userdata = response.data.data.user;
            this.im = response.data.data.reportId.pic;
            if (response.data.data.division) {
              if (response.data.data.division.length > 0) {
                this.divisionid = response.data.data.division[0]._id;
                this.division = response.data.data.division;
              }
            }
            if (response.data.data.reportId.pic !== null) {
              this.image =
                "https://sarpatnapi.leopardtechlabs.in/u/" + response.data.data.reportId.pic;
            }
             var temp = [];
            var ty = {
                lat : response.data.data.reportId.location[0],
                lng : response.data.data.reportId.location[1],
                type: 'Reported Location'
            }
            temp.push (ty);
            if(response.data.data.rescue.location.length > 0){
            var ty1 = {
                lat : response.data.data.rescue.location[0],
                lng : response.data.data.rescue.location[1],
                type: 'Rescued Location'
            }
            temp.push(ty1)
            }
             if(response.data.data.release.location.length > 0){
            var ty1 = {
                lat : response.data.data.release.location[0],
                lng : response.data.data.release.location[1],
                type: 'Released Location'
            }
            temp.push(ty1)
            }
             var mapOptions = {
            // eslint-disable-next-line
            center: new google.maps.LatLng(response.data.data.reportId.location[1], response.data.data.reportId.location[0]),
            zoom: 8,
            // eslint-disable-next-line
            mapTypeId: google.maps.MapTypeId.HYBRID
            }
            vm.map = new google.maps.Map(mapCanvas, mapOptions)
            for(var i=0; i<temp.length;i++){
            var lat = temp[i].lat;
            var lon = temp[i].lng;
            var latlngset = new google.maps.LatLng(lon, lat);
            if(temp[i].type == 'Reported Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_pink.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            if(temp[i].type == 'Rescued Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_blue.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            if(temp[i].type == 'Released Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_yellow.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            // eslint-disable-next-line
            marker = new google.maps.Marker({
              map: vm.map,
              position: latlngset,
              icon: iconBase,
            });
            // vm.oMarker[i] = {
            //   m: marker,
            //   c: id
            // }
            var content = temp[i].type;
            var infowindow = new google.maps.InfoWindow();
            google.maps.event.addListener(
              marker,
              "click",
              (function (marker, content, infowindow) {
                return function () {
                  infowindow.setContent(content);
                  infowindow.open(vm.map, marker);
                };
              })(marker, content, infowindow)
            );
            }
            this.getList();
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((err) => {
         console.log(err)
          alert("No Network Found!!");
        });
    },
    getList() {
      this.visible = true;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/rescuer/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { division: this.divisionid },
      })
        .then((response) => {
          this.visible = false;

          if (response.data.status === true) {
            this.item = response.data.data;
            console.log("items1");
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },
    assign(evt1) {
      this.loading = true;

      evt1.preventDefault();
      axios({
        method: "GET",

        url: "https://sarpatnapi.leopardtechlabs.in/operation/assign",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { reportid: this.id, userid: this.assignedTo },
      })
        .then((response) => {
          if (response.data.status) {
            alert("Assigned Successfully");
            this.$router.push("/pending");
          } else {
            alert(response.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = true;
        });
    },
           deleteItem: function (item) {
        if (confirm("Are you sure?")) {
      var vm = this;
      vm.item = this.id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/delete",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("Operation was successfully Deleted");
           this.$router.push("/pending/");
        })
        .catch((e) => {});
          }
    },
        close(evt) {
      this.loading = true;
      var data = {};
      data["id"] = this.id;
      data["remarks"] = this.closingremarks;
      evt.preventDefault();
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/closereport",
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            alert("Operation Closed Successfully");
            this.$router.push("/pending");
          } else {
            alert(response.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = true;
        });
    },
  },
};
</script>
<style>
.modal-footer {
  display: none !important;
}
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
#map {
  height: 350px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/operation/assign.vue